
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


require('./dashboard');
require('./account');
require('./assessment');

//**********************************************************************************************************************
/**
* COMPANY: Zipline Interactive
* EMAIL: info@gozipline.com
* PHONE: 509-321-2849
* DESCRIPTION: This document contains programming required for the website templates.  Requires the jQuery library.
*/
//***********************************************************************************************************************


//***********************************************************************************************************************
//ON DOCUMENT READY FUNCTIONS
//***********************************************************************************************************************
$(function() {


$(document).ready(function(){
    $(".log-in-button").click(function(){
        $(".header-right > form").addClass("show-form");
    });
    $(".header-form-cross").click(function(){
        $(".header-right > form").removeClass("show-form");
    });
});


$('.open_questions').click(function () {
    if ($(window).width() < 990) {
        $('.questions_flyout').slideDown(600);
    }
});
$('.question_selected').click(function () {
    if ($(window).width() < 990) {
        $('.questions_flyout').slideUp(600);
    }
});
$('.close_btn').click(function () {
    if ($(window).width() < 990) {
        $('.questions_flyout').slideUp(600);
    }
});
    if ( $('[type="date"]').prop('type') != 'date' ) {
        $('[type="date"]').datepicker();
    }
});



//**********************************************************************************************************************
/**
* COMPANY: Zipline Interactive
* EMAIL: info@gozipline.com
* PHONE: 509-321-2849
* DESCRIPTION: This document contains programming required for the website templates.  Requires the jQuery library.
*/
//***********************************************************************************************************************


//***********************************************************************************************************************
//ON DOCUMENT READY FUNCTIONS
//***********************************************************************************************************************

(function() {

	// function changeIcon(){
	// 	$('.single-stage').find('i').removeClass('fa-minus-circle').addClass('fa-plus-circle')
	// 	$('.single-stage.open').find('i').addClass('fa-minus-circle').removeClass('fa-plus-circle')
	// }

	$(document).ready(function(){
        $('body').tooltip({
            selector: '[data-toggle="tooltip"]',
            boundary: 'window'
        });
		$('nav > ul > li').on('click', function(){
			if( $(window).width() < 768 ){
				$(this).children('ul').slideToggle()
			}
		})

		$('.stage-header').on('click', function(){

			$(this).parent().siblings().removeClass('open')
			$(this).parent().toggleClass('open')

			changeIcon()
		})

		$('.next-step').on('click', function(){
			$(this).closest('.single-stage').removeClass('open')
			$(this).closest('.single-stage').next().toggleClass('open')

			changeIcon()
		})

		$('.menu-icon').on('click', function(){
			$('nav').addClass('open')
			$('.nav-bg').fadeIn()
		})
		$('.nav-close').on('click', function(){
			$('nav').removeClass('open')
			$('.nav-bg').fadeOut()
		})

        $('.nav-bg').on('click', function(){
            $('nav').removeClass('open')
            $('.nav-bg').fadeOut()
        })

		$('body').on('click', function(e){
			// console.log(e.target)
		})

		$('.contact-form').on('submit', function(e){

        e.preventDefault()

        var form = this,
            token = grecaptcha.getResponse()

        $.post(
          'validation.php',
          {
            response: token
          },
          function(response){

             if( JSON.parse(response).success ) {
                $('.message').hide()
                form.submit()
             } else {
                $('.message').show()
             }
        })
      })

	})
})();



$(document).ready(function(){
		$('.question-left dd').hide();
		$('.question-left dd').eq(0).show();
	    $('dt').on('click', function(){
	    	$('.question-left dd').slideUp();
	        $(this).siblings('dd').slideDown();
	    });
	    // Initialization
        // $('#my-element').datepicker();
        // // Access instance of plugin
        // $('#my-element').data('datepicker');
});




function setPhoneFormat(id = 0){
    consol.log(id);
    var phones = [{ "mask": "(###) ###-####"}, { "mask": "(###) ###-##############"}];
    $('#'+ id).inputmask({
        mask: phones,
        greedy: false,
        definitions: {'#': {validator: "[0-9]", cardinality: 1}}
    });
};

function defer(id) {
    if (window.jQuery) {
        setPhoneFormat(id);
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}
